"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sleep = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
exports.default = sleep;
//# sourceMappingURL=sleep.js.map